import React, { Component, Fragment } from 'react';
import Head from 'next/head';
import { i18n } from 'next-i18next';
import { buildImgixUrl } from 'integrations/imgix.ts';

const withHomePageLayout = (App, isInsideAdminView = false) =>
  class WithHomePageLayout extends Component {
    handlePFESurveyLinkUpdate = () => {
      [...document.querySelectorAll('a[href]')].forEach((tag) => {
        if (tag.href.includes('/survey_tools/')) {
          tag.setAttribute(
            'href',
            tag.href.replace('/survey_tools/', '/surveys/'),
          );
        }
      });
    };

    componentDidMount() {
      if (this.props.isPFESurveyEnabled) {
        window.addEventListener('load', this.handlePFESurveyLinkUpdate);
      }
    }

    render() {
      const {
        siteName,
        siteLogo,
        faviconUrl,
        siteUrl,
        customTrackingCode,
        nonceValue,
      } = this.props;

      const translatedSiteName = `${i18n.t('editor:editor.siteDescription', {
        siteName: siteName,
      })}`;

      const translatedWebSite = `${i18n.t('editor:editor.website')}`;

      return (
        <Fragment>
          <Head>
            {!isInsideAdminView && (
              <>
                <title>{siteName}</title>
                {faviconUrl && (
                  <link
                    nonce={nonceValue}
                    href={buildImgixUrl(faviconUrl)}
                    rel="icon"
                    type="image/ico"
                  />
                )}
                <meta content={siteName} property="og:site_name" />
                <meta content={siteName} property="og:title" />
                <meta content={buildImgixUrl(siteLogo)} property="og:image" />
                <meta content="100" property="og:image:width" />
                <meta content="100" property="og:image:height" />
                <meta content={translatedWebSite} property="og:type" />
                <meta content={`${siteUrl}/projects`} property="og:url" />
                <meta content={translatedSiteName} property="og:description" />
                <meta content={translatedSiteName} name="Description" />
              </>
            )}

            <link
              rel="stylesheet"
              type="text/css"
              href="/static/assets/css/participant-header-and-footer-styles.css"
            />
            <link
              rel="stylesheet"
              type="text/css"
              href="/static/assets/css/user-dropdown.css"
            />
            <link
              rel="stylesheet"
              type="text/css"
              href="/static/assets/css/froala.css"
            />
            <link
              rel="stylesheet"
              type="text/css"
              href="/static/assets/css/animate-card.css"
            />
            <link
              rel="stylesheet"
              charSet="UTF-8"
              href="/static/assets/css/slick/slick.min.css"
            />
            <link
              rel="stylesheet"
              href="/static/assets/css/slick/slick-theme.min.css"
            />
            <link
              rel="stylesheet"
              href="/static/assets/css/metismenujs.min.css"
            />
            <link
              nonce={nonceValue}
              rel="stylesheet"
              href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
            />
          </Head>

          <App {...this.props} />

          <script
            nonce={nonceValue}
            src="https://cdn.jsdelivr.net/npm/metismenujs@1.2.0/dist/metismenujs.min.js"
          />
          <script
            nonce={nonceValue}
            src="https://unpkg.com/boxicons@latest/dist/boxicons.js"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css"
          />
          {customTrackingCode && !isInsideAdminView && (
            <script
              src="/custom_tracking_code.js"
              type="text/javascript"
              async
              nonce={nonceValue}
            />
          )}
        </Fragment>
      );
    }
  };

export default withHomePageLayout;
